import { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";

import { spokenDeviceName } from "@recital-master/shared";

import { BrandCurtain } from "@/components/BrandCurtain";
import {
  DeviceLimitDialog,
  StreamTakeoverDialog
} from "@/components/dialogs";
import { Button } from "@/design/Button";
import { Screen } from "@/design/primitives";
import { Muted, Text } from "@/design/Text";
import { space } from "@/design/tokens";

/** Design-review harness for the account-security dialogs (dev only). */
export default function DialogPreviewScreen() {
  const [open, setOpen] = useState<"takeover" | "limit" | "curtain" | null>(null);

  if (open === "curtain") {
    return (
      <Pressable style={styles.curtainWrap} onPress={() => setOpen(null)}>
        <BrandCurtain />
      </Pressable>
    );
  }

  return (
    <Screen>
      <View style={styles.wrap}>
        <Text variant="display">Dialog previews</Text>
        <Muted>Design harness — these get wired to real playback events.</Muted>
        <View style={styles.buttons}>
          <Button label="Stream takeover" variant="secondary" onPress={() => setOpen("takeover")} />
          <Button label="Device limit" variant="secondary" onPress={() => setOpen("limit")} />
          <Button label="Brand curtain" variant="secondary" onPress={() => setOpen("curtain")} />
        </View>
      </View>

      <StreamTakeoverDialog
        visible={open === "takeover"}
        activeDeviceLabel={spokenDeviceName({
          platform: "android",
          formFactor: "phone",
          operatingSystem: "Android"
        })}
        onWatchHere={() => setOpen(null)}
        onCancel={() => setOpen(null)}
      />
      <DeviceLimitDialog
        visible={open === "limit"}
        onManageDevices={() => setOpen(null)}
        onClose={() => setOpen(null)}
      />
    </Screen>
  );
}

const styles = StyleSheet.create({
  wrap: {
    gap: space.md,
    marginTop: space.xl
  },
  buttons: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: space.md,
    marginTop: space.lg
  },
  curtainWrap: {
    flex: 1
  }
});
